export enum RealiseerbaarheidEnum {
  REALISEERBAARHEID_20 = 20,
  REALISEERBAARHEID_40 = 40,
  REALISEERBAARHEID_60 = 60,
  REALISEERBAARHEID_80 = 80,
  REALISEERBAARHEID_100 = 100,
}
